/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { ChangeEvent, useEffect, useState } from "react";
import { Backend, Frontend } from "shared-types";
import { RuleObject } from "antd/es/form";
import { T_TrackMetadata } from "@type/global.types";
import { Performer } from "../edit-track/Performer";
import { filterOption, getSelectOptions, getSelectedOptions } from "../../../utils";
import dayjs, { Dayjs } from "dayjs";
import { defaultSelect, defaultTrackMetadata } from "./constants";
import {
  AutoComplete,
  Form,
  Input,
  Select,
  DatePicker,
  Space,
  Button,
  message,
} from "antd";
import {
  LoadingOutlined,
  SaveOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import "../../../assets/scss/components/track/tageditor.scss";
import { Genre } from "../../../actions";
import {
  getSearchTrackTitleList,
  getCountryList,
  getLanguages,
  getMoods,
  getRoles,
  getPublisher,
  getCopyRightP,
} from "../../../actions/user";
import { getCopyrightP, getLicensor } from "../../../actions/suggest";
import { getLicensorOPtionsFromApi } from "../../../hooks/useOverlay";
import { release } from "os";


const { TextArea } = Input;

interface TrackMetaDataFormProps {
  formData:
  | { type: "meta-data"; data: T_TrackMetadata }
  | { type: "post-data"; data: Frontend.T_TrackMetadataOutput };
  onSubmit?: (metaData: T_TrackMetadata) => void;
  disabled?: boolean;
  setFormData: (data: T_TrackMetadata) => void;
  onClickImport?: () => void;
  onClickExport?: (data: T_TrackMetadata) => void;
}

export enum TrackExportType {
  excel,
  xml,
}

const trackTypes = [
  {
    value: "Original",
    label: "Original",
  },
  {
    value: "Karaoke",
    label: "Karaoke",
  },
  {
    value: "Medley",
    label: "Medley",
  },
  {
    value: "Cover",
    label: "Cover",
  },
];

const yesNoSelect = [
  {
    value: 0,
    label: "Yes",
  },
  {
    value: 1,
    label: "No",
  },
];

function item<T = number>(item: Frontend.T_SelectItem<T> | undefined): Frontend.T_SelectItem<T> | undefined {
  if (item === undefined) return undefined;
  else if (item?.label === "" && (item?.value === -1 || item?.value === ""))
    return undefined;
  else return item;
}

export const TrackMetadataForm: React.FC<TrackMetaDataFormProps> = (
  props: TrackMetaDataFormProps
) => {
  const [genreList, setGenreList] = useState<Backend.T_Genre[]>([]);
  const [moodList, setMoodList] = useState<Backend.T_Mood[]>([]);
  const [roleList, setRoleList] = useState<Backend.T_MemberRole[]>([]);
  const [languageList, setLanguageList] = useState<Backend.T_Language[]>([]);
  const [licensorList, setLicensorList] = useState<any[]>([]);
  const [publisherList, setPublisherList] = useState<any[]>([]);
  const [isLoading, setLoading] = useState(false);
  const [isSearchTitleLoading, setSearchTitleLoading] = useState(false);
  const [isFormDisable, setFormDisable] = useState<boolean>(true);
  const [trackTitleSearchList, setTrackTitleSearchList] = useState<
    Frontend.T_SelectItem[]
  >([]);
  const [circleP, setCircleP] = useState<any[]>([]);
  const [countryList, setCountryList] = useState<Frontend.T_SelectItem[]>([]);
  const [timer, setTimer] = useState<any>();
  const { formData, setFormData } = props;
  const [form] = Form.useForm();

  useEffect(() => {
    const main = async () => {
      // const hide = message.loading("Loading form data. just a second...", 1000);
      // setLoading(true);
      // setFormDisable(true);
      let genreRes = await Genre.all();
      genreRes?.map((genre) => genreList.push(genre));
      setGenreList([...genreList]);
      let langRes = await getLanguages();
      langRes?.map((language) => languageList.push(language));
      setLanguageList([...languageList]);
      let licensorRes = await getLicensor("");
      licensorRes.result?.list?.map((licensor: any) => licensorList.push(licensor));
      setLicensorList([...licensorList]);
      let publisherRes = await getPublisher();
      publisherRes?.map((publisher: any) => publisherList.push(publisher));
      setPublisherList([...publisherList]);

      let circlePRes = await getCopyrightP("");
      circlePRes.result.list?.map((copyright: any) => circleP.push(copyright));
      setCircleP([...circleP]);
      const moodRes = await getMoods()
      moodRes.map((mood) => moodList.push(mood));
      setMoodList([...moodList]);
      let roleRes = await getRoles();
      roleRes.map((role) => roleList.push(role));
      setRoleList([...roleList]);
      await initCountryList();
      // const hideLoading = () => {
      //   setLoading(false);
      //   setFormDisable(false);
      // };
      // setTimeout(hideLoading, 1000);
      // hide();
    };
    main();
  }, []);

  const initCountryList = async () => {
    if (countryList.length < 10) {
      let response = (await getCountryList({})).countries;
      response?.map((item: any) => {
        return countryList.push({
          value: item.id,
          label: item.title,
        });
      });
      setCountryList([...countryList]);
    }
  };

  const getFormData = (
    data:
      | { type: "meta-data"; data: T_TrackMetadata }
      | { type: "post-data"; data: Frontend.T_TrackMetadataOutput }
  ) => {
    if (data.type === "meta-data") return data.data;
    else return getFormDataFromPostData(data.data);
  };

  const generateIsrc = () => {
    var randomNumbers = Math.floor(1000 + Math.random() * 9000);
    // var year = getFormData(formData).yearOfPublication.year();
    //`DEB79${year}9${randomNumbers}`;
    return `DEB7920229${randomNumbers}`;
  };

  const getFormDataFromPostData = (
    postData: Frontend.T_TrackMetadataOutput
  ) => {
    let res: T_TrackMetadata = {
      ...defaultTrackMetadata,
      genre: defaultSelect.number,
      subGenre: defaultSelect.number,
      trackType: defaultSelect.string,
      titleLanguage: defaultSelect.number,
      licensor: defaultSelect.number,
      mood: defaultSelect.number,
    };

    let data = genreList.find((item) => item.id === postData.genre_id);
    if (data && postData.genre_id) {
      res.genre = {
        value: Number(postData.genre_id),
        label: data.title,
      };
    }

    data = genreList.find((item) => item.id === postData.fileunder_id);
    if (data && postData.genre_id) {
      res.subGenre = {
        value: postData.fileunder_id || 0,
        label: data.title,
      };
    }

    let langData = languageList.find(
      (item) => item.id === postData.title_lang_id
    );
    if (langData && postData.title_lang_id) {
      res.titleLanguage = {
        value: postData.title_lang_id,
        label: langData.title,
      };
    }
    langData = languageList.find((item) => item.id === postData.lyrics_lang_id);
    if (langData && postData.lyrics_lang_id) {
      res.language = postData.lyrics_lang_id;
    }
    res.trackTitle = postData.track_title;
    res.titleLanguage =
      languageList
        .map((item) => ({ label: item.title, value: item.id }))
        .find((item) => item.value === postData.title_lang_id) ||
      defaultSelect.number;

    res.licensor =
      licensorList
        .map((item) => ({ label: item.label, value: item.value }));

    res.trackPart = postData.track_part;
    res.startOfPreview = postData.start_of_preview;
    const tp = trackTypes.find((item) => item.value === postData.track_type);
    if (tp) res.trackType = tp;
    if (postData.publisher_id) res.publisher_id = postData.publisher_id;
    if (postData.price_code) res.priceCode = postData.price_code;
    if (postData.explicit_content)
      res.explicitContent = postData.explicit_content;
    if (postData.circle_p) res.circleP = postData.circle_p;
    if (postData.publication_date)
      res.yearOfPublication = dayjs(postData.publication_date);
    if (postData.catalogue_num) res.catalogue_num = postData.catalogue_num;
    if (postData.start_of_preview)
      res.startOfPreview = postData.start_of_preview;
    if (postData.release_date) res.releaseDate = dayjs(postData.release_date);
    if (
      postData.distribution_territories &&
      postData.distribution_territories.length
    ) {
      let nData: Frontend.T_SelectItem[] = [];
      postData.distribution_territories.map((item) => {
        const f = countryList.find(
          (country) => Number(country.value) === Number(item)
        );
        if (f) nData.push(f);
      });
      res.distributionTerr = nData;
    }
    if (postData.lyrics) res.lyrics = postData.lyrics;
    try {
      res.performers = [];
      postData.members?.map((member) => {
        res.performers.push({
          title: member.member_title,
          id: member.member_id,
          role: member.role_id,
          primary: member.primary,
        });
      });
    } catch (error) {
      res.performers = [];
    }
    if (postData.track_file != null) res.trackFile = postData.track_file;
    res.register_from = 2;
    if (postData.track_file_name != null)
      res.trackFileName = postData.track_file_name;
    if (postData.version != null) res.version = postData.version;
    const mood = moodList.find((item: any) => item.id === postData.mood_id);
    if (mood)
      res.mood = {
        value: mood.id,
        label: mood.title || "",
      };
    res.isrc = postData.isrc;
    res.source = postData.source;
    res.source_cd = postData.source_cd;
    return res;
  };

  useEffect(() => {
    const data = getFormData(formData);
    form.setFieldsValue({
      ...data,
      trackTitle: data.trackTitle ? data.trackTitle : "",
      priceCode: data.priceCode ? data.priceCode : "",
      titleLanguage:
        data.titleLanguage?.value !== -1 ? data.titleLanguage : undefined,
      licensor:
        data.licensor?.value !== -1 ? data.licensor : undefined,
      trackType: data.trackType?.value?.length ? data.trackType : undefined,
      genre: data.genre?.value !== -1 ? data.genre : undefined,
      subGenre: data.subGenre?.value !== -1 ? data.subGenre : undefined,
      mood: data?.mood?.value !== -1 ? data.mood : undefined,
      releaseDate: data?.releaseDate ? data.releaseDate : "",
    });
  }, [formData, isFormDisable]);



  /*********************   Form change event handlers start *********************/

  const onSearchTrackTitle = (e: string) => {
    clearTimeout(timer);
    // setTimer(setTimeout(() => handleTrackTitleSearch(e), 500));
  };

  const onChangeTrackTitle = (value: string) => {
    const data = getFormData(formData);
    setFormData({
      ...data,
      trackTitle: value,
    });
  };

  const onChangeLanguage = (_: any, val: Frontend.T_SelectItem) => {
    setFormData({ ...getFormData(formData), titleLanguage: val });
  };

  const onChangeGenre = (_: any, val: Frontend.T_SelectItem) => {
    setFormData({ ...getFormData(formData), genre: val });
  };

  const onChangeSubGenre = (_: any, val: Frontend.T_SelectItem) => {
    setFormData({ ...getFormData(formData), subGenre: val });
  };

  const onChangeMood = (_: any, val: Frontend.T_SelectItem) => {
    setFormData({ ...getFormData(formData), mood: val });
  };

  const onChangeTractPart: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setFormData({ ...getFormData(formData), trackPart: e.target.value });
  };


  function onChangeInstrumental(value: any) {
    setFormData({ ...getFormData(formData), instPossibleVal: value });
  }



  function onChangeCatalogue(event: ChangeEvent<HTMLInputElement>): void {
    setFormData({
      ...getFormData(formData),
      catalogue_num: event.target.value,
    });
  }


  function onChangeISRC(event: ChangeEvent<HTMLInputElement>): void {
    setFormData({ ...getFormData(formData), isrc: event.target.value });
  }

  async function onClickGenerateISRC() {
    const isrc = generateIsrc();
    form.setFieldsValue({
      isrc,
    });
    setFormData({
      ...getFormData(formData),
      isrc
    });
  }

  function onChangeSource(event: ChangeEvent<HTMLInputElement>): void {
    setFormData({ ...getFormData(formData), source: event.target.value });
  }
  async function onClickGenerateSource() {
    const source = generateIsrc();
    form.setFieldsValue({
      source,
    });
    setFormData({
      ...getFormData(formData),
      source
    });
  }

  function onChangeSourceCD(event: ChangeEvent<HTMLInputElement>): void {
    setFormData({ ...getFormData(formData), source_cd: event.target.value });
  }
  async function onClickGenerateSourceCD() {
    const source_cd = generateIsrc();
    form.setFieldsValue({
      source_cd,
    });
    setFormData({
      ...getFormData(formData),
      source_cd
    });
  }

  function onChangeCircleP(value: any) {
    setFormData({ ...getFormData(formData), circleP: value });
  }

  function onChangeStartOfPreview(event: ChangeEvent<HTMLInputElement>): void {
    setFormData({
      ...getFormData(formData),
      startOfPreview: Number(event.target.value),
    });
  }

  function onChangeReleaseDate(value: Dayjs | null): void {
    if (value !== null)
      setFormData({ ...getFormData(formData), releaseDate: value });
  }

  function onChangeVersion(event: ChangeEvent<HTMLInputElement>): void {
    setFormData({ ...getFormData(formData), version: event.target.value });
  }

  function onChangeLyricsLanguage(value: number) {
    setFormData({ ...getFormData(formData), language: value });
  }

  function onChangeLicensor(value: number) {
    setFormData({ ...getFormData(formData), licensor: value });
  }

  function onChangeDistributionTerr(
    _value: Frontend.T_SelectItem<number>[],
    option: Frontend.T_SelectItem<number> | Frontend.T_SelectItem<number>[]
  ): void {
    if (option instanceof Array)
      setFormData({ ...getFormData(formData), distributionTerr: option });
    else setFormData({ ...getFormData(formData), distributionTerr: [option] });
  }

  function onChangeLyrics(event: ChangeEvent<HTMLTextAreaElement>): void {
    setFormData({ ...getFormData(formData), lyrics: event.target.value });
  }

  function onChangePerformer(performers: Performer[]) {
    setFormData({ ...getFormData(formData), performers: [...performers] });
  }

  const onChangePublisher = (_: any, val: any) => {
    setFormData({ ...getFormData(formData), publisher_id: val });
  };


  async function onFormSubmit() {
    if (props.onSubmit) {
      props?.onSubmit(getFormData(formData));
    }
  }

  /*********************   Form change event handlers end   *********************/

  return (
    <div className="page-tageditor">
      <div className="tw-py-3  tw-mx-10">
        <Form
          name="track-edit-form"
          labelCol={{ span: 12 }}
          onFinish={onFormSubmit}
          layout="vertical"
          className="tw-grid tw-gap-4 tw-grid-cols-12 tw-py-8 track-meta-form"
          size="large"
          form={form}
          initialValues={formData}
          disabled={props.disabled || isLoading || isFormDisable}
        >
          <Form.Item
            label="Title"
            name="trackTitle"
            rules={[
              {
                required: true,
                message: "Please input track title",
              },
            ]}
            className="tw-col-span-12"
          >
            <AutoComplete
              onSearch={onSearchTrackTitle}
              onChange={onChangeTrackTitle}
              onSelect={onChangeTrackTitle}
              options={isLoading ? [] : trackTitleSearchList}
              value={getFormData(formData).trackTitle}
              placeholder="Search keyword"
              notFoundContent={
                isSearchTitleLoading ? <LoadingOutlined rev={undefined} /> : ""
              }
            />
          </Form.Item>
          <Form.Item
            label="Track Part"
            name="trackPart"
            className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
          >
            <Input
              onChange={onChangeTractPart}
              value={getFormData(formData).trackPart}
            />
          </Form.Item>
          <Form.Item
            label="Genre"
            name="genre"
            rules={[
              {
                required: true,
                message: "Please select genre",
              },
            ]}
            className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
          >
            <Select
              options={getSelectOptions(
                genreList.filter(
                  (genre) =>
                    genre.parent_id === 0 &&
                    genreList.find((item) => item.parent_id === genre.id)
                )
              )}
              showSearch
              filterOption={filterOption}
              onSelect={onChangeGenre}
              value={item(getFormData(formData).genre)}
            />
          </Form.Item>
          <Form.Item
            label="Sub Genre"
            name="subGenre"
            rules={[
              {
                required: true,
                message: "Please select sub genre",
              },
            ]}
            className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
          >
            <Select
              options={getSelectOptions(
                getFormData(formData).genre.value === 0
                  ? []
                  : genreList.filter(
                    (genre) =>
                      genre.parent_id === getFormData(formData).genre.value
                  )
              )}
              showSearch
              filterOption={filterOption}
              onSelect={onChangeSubGenre}
              value={getFormData(formData).subGenre}
            />
          </Form.Item>
          <Form.Item
            label="Copyright C"
            name="copyrightC"
            rules={[
              {
                required: true,
                message: "Please select copyrightC",
              },
            ]}
            className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
          >
            <Select
              options={getSelectedOptions(circleP)}
              showSearch
              filterOption={filterOption}
              value={getFormData(formData).circleP}
              onSelect={onChangeCircleP}
              maxLength={1}
            />
          </Form.Item>

          <Form.Item
            label="Copyright C Date"
            name="copyrightCDate"
            rules={[
              {
                required: true,
                message: "Please select copyrightC date",
              },
            ]}
            className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
          >
            <Select
              options={getSelectedOptions(circleP)}
              showSearch
              filterOption={filterOption}
              value={getFormData(formData).circleP}
              onSelect={onChangeCircleP}
              maxLength={1}
            />
          </Form.Item>
          <Form.Item
            label="Copyright P"
            name="circleP"
            className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
          >
            <Select
              options={getSelectedOptions(circleP)}
              showSearch
              filterOption={filterOption}
              value={getFormData(formData).circleP}
              onSelect={onChangeCircleP}
              maxLength={1}
            />

          </Form.Item>
          <Form.Item
            label="Publisher"
            name="publisher"
            className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
          >
            <Select
              options={getSelectedOptions(publisherList)}
              showSearch
              filterOption={filterOption}
              value={getFormData(formData).publisher_id}
              onSelect={onChangePublisher}
              maxLength={1}
            />
          </Form.Item>
          <Form.Item
            label="ISRC"
            name="isrc"
            className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
            validateTrigger={["onChange", "onBlur"]}
          >
            <Space.Compact className="tw-w-full" size="large">
              <Input value={getFormData(formData).isrc} onChange={onChangeISRC} />
              <Button
                className="tw-w-[40px] ant-input-compact-second-item"
                onClick={onClickGenerateISRC}
                icon={
                  <ReloadOutlined
                    rev={undefined}
                    className="tw-text-blue-600 !tw-inline-flex"
                  />
                }
              ></Button>
            </Space.Compact>
          </Form.Item>

          <Form.Item
            label="Source"
            name="source"
            className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
            validateTrigger={["onChange", "onBlur"]}
          >
            <Space.Compact className="tw-w-full" size="large">
              <Input value={getFormData(formData).source} onChange={onChangeSource} />
              <Button
                className="tw-w-[40px] ant-input-compact-second-item"
                onClick={onClickGenerateSource}
                icon={
                  <ReloadOutlined
                    rev={undefined}
                    className="tw-text-blue-600 !tw-inline-flex"
                  />
                }
              ></Button>
            </Space.Compact>
          </Form.Item>

          <Form.Item
            label="Source CD"
            name="source_cd"
            className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
            validateTrigger={["onChange", "onBlur"]}
          >
            <Space.Compact className="tw-w-full" size="large">
              <Input value={getFormData(formData).source_cd} onChange={onChangeSourceCD} />
              <Button
                className="tw-w-[40px] ant-input-compact-second-item"
                onClick={onClickGenerateSourceCD}
                icon={
                  <ReloadOutlined
                    rev={undefined}
                    className="tw-text-blue-600 !tw-inline-flex"
                  />
                }
              ></Button>
            </Space.Compact>
          </Form.Item>

          <Form.Item
            label="Catalogue Number"
            name="catalogue_num"
            className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
            rules={[
              {
                required: true,
                message: "Please input catalogue number",
              },
            ]}
          >
            <Input
              value={getFormData(formData).catalogue_num}
              onChange={onChangeCatalogue}
            />
          </Form.Item>

          <Form.Item
            label="Mood"
            name="mood"
            className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
          >
            <Select
              options={getSelectOptions(moodList)}
              showSearch
              filterOption={filterOption}
              onSelect={onChangeMood}
              value={item(getFormData(formData).mood)}
            />
          </Form.Item>
          <Form.Item
            label="Instrumental"
            name="instPossibleVal"
            rules={[
              {
                required: true,
                message: "Please select instrumental",
              },
            ]}
            className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
          >
            <Select
              options={yesNoSelect}
              onChange={onChangeInstrumental}
              value={getFormData(formData).instPossibleVal}
            />
          </Form.Item>
          <Form.Item
            label="Release Date"
            name="releaseDate"
            className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
            rules={[
              {
                required: true,
                message: "Please select release date",
              },
            ]}
          >

            <DatePicker
              className="tw-w-full"
              onChange={onChangeReleaseDate}
              value={dayjs(getFormData(formData)?.releaseDate)}
              format={"DD.MM.YYYY"}
            />
          </Form.Item>
          <Form.Item
            label="Version"
            name="version"
            className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
          >
            <Input
              value={getFormData(formData).version}
              onChange={onChangeVersion}
            />
          </Form.Item>
          <Form.Item
            label="Language"
            name="titleLanguage"
            rules={[
              {
                required: true,
                message: "Please select language",
              },
            ]}
            className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
          >
            <Select
              options={getSelectOptions(languageList)}
              showSearch
              filterOption={filterOption}
              value={item(getFormData(formData).titleLanguage)?.value}
              onSelect={onChangeLanguage}
              maxLength={1}
            />
          </Form.Item>
          <Form.Item
            label="Lyrics Language"
            name="language"
            className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
          >
            <Select
              options={getSelectOptions(languageList)}
              showSearch
              filterOption={filterOption}
              value={item(getFormData(formData).titleLanguage)?.value}
              onChange={onChangeLyricsLanguage}
            />
          </Form.Item>
          <Form.Item
            label="Licensor"
            name="licensor"
            className="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4"
          >
            <Select
              options={getSelectedOptions(licensorList)}
              showSearch
              filterOption={filterOption}
              value={getFormData(formData).licensor}
              onChange={onChangeLicensor}
            />
          </Form.Item>


          <Form.Item
            label="Distribution territories"
            name="distributionTerr"
            className="tw-col-span-12"
          >
            <Select
              options={countryList}
              showSearch
              filterOption={filterOption}
              tokenSeparators={[","]}
              mode="tags"
              value={getFormData(formData).distributionTerr}
              onChange={onChangeDistributionTerr}
            />
          </Form.Item>
          <Form.Item
            label="Lyrics"
            name="lyrics"
            className="tw-col-span-12 md:tw-col-span-6"
          >
            <TextArea
              rows={4}
              value={getFormData(formData).lyrics}
              onChange={onChangeLyrics}
            />
          </Form.Item>
        </Form>
      </div>
    </div >
  );
};
